import React from "react";
import Seo from "./Seo";
import { EFFECTIVE_DATE, CONTACT_EMAIL } from "../lib/content";

export default function LegalLayout({ title, seoPath, intro, sections }) {
  return (
    <div className="relative">
      <Seo title={title} path={seoPath} description={`${title} for Jollof Fit Kingdom — ${intro?.slice(0, 120)}`} />
      <div className="pointer-events-none absolute inset-x-0 top-0 h-80 radial-fade" />
      <div className="relative mx-auto max-w-3xl px-6 pt-40 pb-10 md:pt-48">
        <p className="eyebrow">Legal</p>
        <h1 className="mt-4 font-heading text-4xl font-medium tracking-tight text-white md:text-5xl">{title}</h1>
        <p className="mt-4 text-sm text-zinc-500">Last updated: {EFFECTIVE_DATE}</p>
        {intro && <p className="mt-8 text-base leading-relaxed text-zinc-400">{intro}</p>}
      </div>

      <article className="relative mx-auto max-w-3xl px-6 pb-24">
        {sections.map((s, i) => (
          <section key={s.heading} className="mt-12" data-testid={`legal-section-${i}`}>
            <h2 className="font-heading text-xl font-medium text-white md:text-2xl">
              {i + 1}. {s.heading}
            </h2>
            {s.body?.map((p, j) => (
              <p key={`${s.heading}-p${j}`} className="mt-4 text-[15px] leading-relaxed text-zinc-400">
                {p}
              </p>
            ))}
            {s.list && (
              <ul className="mt-4 space-y-2.5">
                {s.list.map((li, k) => (
                  <li key={`${s.heading}-l${k}`} className="flex gap-3 text-[15px] leading-relaxed text-zinc-400">
                    <span className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-gold/60" />
                    <span>{li}</span>
                  </li>
                ))}
              </ul>
            )}
          </section>
        ))}

        <div className="mt-14 rounded-2xl border border-white/10 bg-[#0a0a0a] p-6">
          <h3 className="font-heading text-lg text-white">Contact</h3>
          <p className="mt-2 text-sm text-zinc-400">
            For questions about this policy, contact us at{" "}
            <a href={`mailto:${CONTACT_EMAIL}`} className="text-gold hover:text-gold-light">
              {CONTACT_EMAIL}
            </a>
            .
          </p>
        </div>
      </article>
    </div>
  );
}
